export const CREDIT_CARD_DEFAULT_STYLES: CreditCardStyles = {
  textColor: 'rgba(4, 37, 62, 0.8)',
  inputFieldColor: 'rgba(255, 255, 255, 1)',
  placeholderColor: 'rgba(4, 37, 62, 0.3)',
  fontSize: '1',
};

export interface CreditCardStyles {
  textColor: string;
  inputFieldColor: string;
  placeholderColor: string;
  fontSize: string;
}
